import { useSuspenseQuery } from '@apollo/client';

import { getGlobalPromptTemplateDefaultsQuery } from '../promptTemplateDefaults.operations';

export const useGlobalPromptDefaultsData = () => {
  const { data, refetch: refetchDefaults } = useSuspenseQuery(
    getGlobalPromptTemplateDefaultsQuery,
  );

  return {
    globalDefaults: data?.globalDefaults ?? [],
    llmOutputTypes: data?.llmOutputTypes ?? [],
    promptTemplates: data?.promptTemplates ?? [],
    outputTemplates: data?.llmOutputTemplates ?? [],
    refetchDefaults,
  };
};
